<template>
    <div v-if="application">

        <h1>제목 : {{ application.subject }}</h1>
        
        <!-- 관리자 작성 항목-->
        <h2 class="mt-4">관리자 작성 항목</h2>
        <table class="mx-auto">
            <tbody>
                <template v-for="item, index in application.items">
                    <tr :key="index">
                        <th>
                            <b v-html="item.title.replace(/\n/g, '<br/>')" class="d-inline" />
                        </th>
                        <td>
                            <p v-html="item.txt.replace(/\n/g, '<br/>')" class="d-inline ma-0" />
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>

        <v-btn href="#content" class="mt-4">상세보기</v-btn>
        
        <!-- 문의처 항목-->
        <v-dialog max-width="640">
            <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="mt-4">문의처</v-btn>
            </template>
            <v-card>
                <table>
                    <tbody>
                        <template v-for="item, index in application.helpItems">
                            <tr :key="index">
                                <th>
                                    <b v-html="item.title.replace(/\n/g, '<br/>')" class="d-inline" />
                                </th>
                                <td>
                                    <p v-html="item.txt.replace(/\n/g, '<br/>')" class="d-inline ma-0" />
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </v-card>
        </v-dialog>

        <v-dialog max-width="480">
            <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="mt-4">공고문 다운로드</v-btn>
            </template>
            <v-card>
                <v-card-title>
                    공고문 다운로드
                </v-card-title>
                <v-card-text>
                    <template v-for="item, index in application.files">
                        <div :key="index">
                            <v-btn color="blue" outlined @click="download(item.src, item.name)">{{ item.name }}</v-btn>
                        </div>
                    </template>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-btn :href="application.link" class="mt-4">지원하기</v-btn>

        <div>
            <v-btn @click="shareKakao">카카오톡</v-btn>
            <v-btn @click="shareFacebook">페이스북</v-btn>
            <v-btn @click="shareInstagram">인스타그램</v-btn>
            <v-btn @click="copyClipboard">복사</v-btn>
        </div>

        <!-- html 작성글 -->
        <div id="content" class="pt-16">
            <h2>상세내용(html)</h2>
            <p v-html="application.content" />
        </div>
    </div>
</template>

<script>
import api from "@/api";
import download from "downloadjs";

export default {
    data(){
        return {
            application: null,
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        download: (url, name) => api.resource.get(url).then(file => download(file, name)),
        async init(){
            if(this.$route.params._id){
                let { application } = await api.v1.kea.applications.get({ _id: this.$route.params._id });
                this.application = application;
            }
        },
        shareKakao(){
            try{
                let key = ""; // 웹 API 키
                if(!key) throw new Error("카카오에서 JAVASCRIPT API 키를 발급받아 전달해주세요.(+ 카카오에 WEB 정보를 등록해주세요)");

                let shareUrl = location.href;

                if(!Kakao.isInitialized()) Kakao.init(key);
                Kakao.Share.sendDefault({
                    objectType: 'feed',
                    content: {
                        title: this.application.subject,
                        // description: '#케익 #딸기 #삼평동 #카페 #분위기 #소개팅',
                        imageUrl: `https://${location.host}/${this.application.thumb.src}`,
                        link: {
                            // [내 애플리케이션] > [플랫폼] 에서 등록한 사이트 도메인과 일치해야 함
                            // mobileWebUrl: 'https://developers.kakao.com',
                            mobileWebUrl: shareUrl,
                            // webUrl: 'https://developers.kakao.com',
                            webUrl: shareUrl,
                        },
                    },
                });
            }
            catch(error){
                alert(error.message);
            }
        },
        shareFacebook(){
            try{
                let shareUrl = location.href;

                location.href = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
            }
            catch(error){
                alert(error.message);
            }
        },
        shareInstagram(){
            try{
                let client_id = ""; // 클라이언트 아이디
                if(!client_id) throw new Error("인스타그램 클라이언트 아이디를 발급받아 전달해주세요.");

                let shareUrl = location.href;
    
                location.href = `https://api.instagram.com/oauth/authorize/?client_id=${client_id}&redirect_uri=${shareUrl}&response_type=code`;
            }
            catch(error){
                alert(error.message);
            }
        },
        copyClipboard(){
            try{
                if(!window?.navigator?.clipboard?.writeText) throw new Error("SSL 환경에서만 클립보드 복사 가능합니다");

                let shareUrl = location.href;

                window.navigator.clipboard.writeText(shareUrl);

                alert("복사 되었습니다");
            }
            catch(error){
                alert(error.message);
            }
        }
    },
}
</script>